module.exports = __webpack_public_path__ + "static/media/lock.e0b3d74b.svg";